import { useDashboardStats } from "@/api/dashboard-home";
import { DatabaseIcon } from "@/components/home/HomeIcons";
import {
  type NavigationLink,
  NavigationCard,
} from "@/components/home/NavigationCard";
import { Checkbox } from "@/components/ui/checkbox";
import { useVisibleT } from "@/lib/cms/cms-new-i18n";

const numberFormat = new Intl.NumberFormat();

const StatTile = ({
  value,
  label,
  onSelect,
}: {
  value?: number;
  label: string;
  onSelect?: () => void;
}) => (
  <button
    type="button"
    onClick={onSelect}
    disabled={!onSelect}
    className="flex min-w-0 flex-1 flex-col rounded-md bg-slate-100 px-3 py-2 text-left transition-colors hover:bg-brand-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:hover:bg-slate-100"
  >
    <span className="text-xl font-semibold text-slate-900">
      {value === undefined ? "—" : numberFormat.format(value)}
    </span>
    <span className="w-full truncate text-xs text-slate-500">{label}</span>
  </button>
);

/**
 * Carte « Mes données » : liens, chiffres des œuvres et case « Afficher les
 * quantités ». Le titre et les chiffres mènent au tableau des œuvres.
 */
export const DataCard = ({
  links,
  onOpenArtworks,
  showCounts,
  onShowCountsChange,
}: {
  links: NavigationLink[];
  onOpenArtworks?: () => void;
  showCounts: boolean;
  onShowCountsChange: (show: boolean) => void;
}) => {
  const vt = useVisibleT();
  const { data: stats } = useDashboardStats();
  return (
    <NavigationCard
      icon={<DatabaseIcon />}
      title={vt("bo.home.data.title", "Mes données")}
      onTitleSelect={onOpenArtworks}
      links={links}
      footer={
        <label className="flex cursor-pointer items-center justify-between gap-3 text-sm text-slate-500">
          {vt("bo.home.data.showCounts", "Afficher les quantités")}
          <Checkbox
            checked={showCounts}
            onCheckedChange={(checked) => onShowCountsChange(checked === true)}
          />
        </label>
      }
    >
      {showCounts && (
        <div className="flex gap-2.5">
          <StatTile
            value={stats?.artworks}
            label={vt("bo.home.data.artworksCount", "oeuvres")}
            onSelect={onOpenArtworks}
          />
          <StatTile
            value={stats?.artworksAddedThisMonth}
            label={vt("bo.home.data.addedThisMonth", "ajoutées ce mois")}
            onSelect={onOpenArtworks}
          />
        </div>
      )}
    </NavigationCard>
  );
};
